import { Dispatch, FC, SetStateAction, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { GetSupplierHearingSheetItemRes } from '@gateway.Supplier'
import { Button } from '@progress/kendo-react-buttons'
import { StackLayout } from '@progress/kendo-react-layout'
import {
  ConfirmDialog,
  ErrorMessage
} from '../../../components/parts'
import { HearingItemGateway } from '../../../gateway/supplier/HearingItemGateway'
import { MessageProvider } from '../../../services'

export interface HearingSheetProps {
  hearingSheetVal: GetSupplierHearingSheetItemRes
  nonCtrlFlg: boolean
  handleGetHearingSheet: () => void
  setNotificationMessages: Dispatch<SetStateAction<ErrorMessage[]>>
  setErrorMessages: Dispatch<SetStateAction<ErrorMessage[]>>
  isChanged: boolean
  resetLeaveGuard: () => void
}

export const HearingSheetFooter: FC<HearingSheetProps> = ({
  hearingSheetVal,
  nonCtrlFlg,
  handleGetHearingSheet,
  setNotificationMessages,
  setErrorMessages,
  isChanged,
  resetLeaveGuard
}) => {
  const navigate = useNavigate()
  const [confirmDialogLaborSaveShow, setConfirmDialogLaborSaveShow] = useState(false)
  const [confirmDialogSignInShow, setConfirmDialogSignInShow] = useState(false)
  /**
   * 一時保存ボタン押下
   */
  const handleLaborSave = () => {
    setConfirmDialogLaborSaveShow(true)
  }
  /**
   * 一時保存ボタン押下
   */
  const dialogConfirmLaborSaveBtn = () => {
    const supplierHearingObj = {
      simulationYm: hearingSheetVal.simulationYm,
      supplierCd: hearingSheetVal.supplierCd,
      supplierBranchCd: hearingSheetVal.supplierBranchCd,
      factoryCd: hearingSheetVal.factoryCd,
      expenseCd: hearingSheetVal.expenseCd,
      addStsCdAfterChange: '2',
      replyNmLast: hearingSheetVal.replyNmLast,
      replyNmFirst: hearingSheetVal.replyNmFirst,
      ourCompanyOccupancy: hearingSheetVal.ourCompanyOccupancy,
      marketTrend: hearingSheetVal.marketTrend,
      yamadumiSts: hearingSheetVal.yamadumiSts,
      newBuildingSts: hearingSheetVal.newBuildingSts,
      problem: hearingSheetVal.problem,
      updDtm: hearingSheetVal.updDtm
    }

    HearingItemGateway.putHearingItem({ data: supplierHearingObj })
      .then((res) => {
        if (!res.error) {
          if (isChanged) {
            resetLeaveGuard()
          }
          setNotificationMessages([
            {
              id: 'I004',
              content: MessageProvider.provide('I004', '一時保存')
            }
          ])
          handleGetHearingSheet()
        } else {
          if (Array.isArray(res.messages) && res.messages.length > 0) {
            const errorMessages = res.messages.map<ErrorMessage>((message) => {
              return {
                id: message.id,
                content: message.message
              }
            })
            setErrorMessages(errorMessages)
          }
        }
      })
      .finally(() => {
        setConfirmDialogLaborSaveShow(false)
      })
  }
  /**
   * 登録ボタン押下
   */
  const handleSignIn = () => {
    setConfirmDialogSignInShow(true)
  }
  /**
   * 登録ボタン押下
   */
  const dialogConfirmSignInBtn = () => {
    setConfirmDialogSignInShow(false)
    const supplierHearingObj = {
      simulationYm: hearingSheetVal.simulationYm,
      supplierCd: hearingSheetVal.supplierCd,
      supplierBranchCd: hearingSheetVal.supplierBranchCd,
      factoryCd: hearingSheetVal.factoryCd,
      expenseCd: hearingSheetVal.expenseCd,
      addStsCdAfterChange: '3',
      replyNmLast: hearingSheetVal.replyNmLast,
      replyNmFirst: hearingSheetVal.replyNmFirst,
      ourCompanyOccupancy: hearingSheetVal.ourCompanyOccupancy,
      marketTrend: hearingSheetVal.marketTrend,
      yamadumiSts: hearingSheetVal.yamadumiSts,
      newBuildingSts: hearingSheetVal.newBuildingSts,
      problem: hearingSheetVal.problem,
      updDtm: hearingSheetVal.updDtm
    }
    HearingItemGateway.putHearingItem({ data: supplierHearingObj })
      .then((res) => {
        if (!res.error) {
          if (isChanged) {
            resetLeaveGuard()
          }
          setNotificationMessages([
            {
              id: 'I004',
              content: MessageProvider.provide('I004', '登録')
            }
          ])
          handleGetHearingSheet()
        } else {
          if (Array.isArray(res.messages) && res.messages.length > 0) {
            const errorMessages = res.messages.map<ErrorMessage>((message) => {
              return {
                id: message.id,
                content: message.message
              }
            })
            setErrorMessages(errorMessages)
          }
        }
      })
      .finally(() => {})
  }
  /**
   * 戻るボタン押下
   */
  const handleGoBack = () => {
    navigate(-1)
  }
  return (
    <div
      className="pcy-search-body-pane-footer pcy-control-box"
      style={{
        backgroundColor: '#FFFFFF'
      }}
    >
      <StackLayout gap={5} align={{ horizontal: 'end' }}>
        <Button onClick={handleGoBack}>戻る</Button>
        {!nonCtrlFlg && (
          <>
            <Button onClick={handleLaborSave} themeColor="primary">
              一時保存
            </Button>
            <Button onClick={handleSignIn} themeColor="primary">
              登録
            </Button>
          </>
        )}
      </StackLayout>
      {confirmDialogLaborSaveShow && (
        <ConfirmDialog
          title="一時保存"
          open={confirmDialogLaborSaveShow}
          renderCloseButton
          id={'I007'}
          args={['一時保存']}
          onClickOk={dialogConfirmLaborSaveBtn}
          onClickCancel={() => setConfirmDialogLaborSaveShow(false)}
        />
      )}
      {confirmDialogSignInShow && (
        <ConfirmDialog
          title="登録"
          open={confirmDialogSignInShow}
          renderCloseButton
          id={'I007'}
          args={['登録']}
          onClickOk={dialogConfirmSignInBtn}
          onClickCancel={() => setConfirmDialogSignInShow(false)}
        />
      )}
    </div>
  )
}
